import React, { useEffect, useRef, useState } from 'react';
import Header from '../components/Header';
import ContentRow from '../components/ContentRow';
import Footer from '../components/Footer';
import ContentModal from '../components/ContentModal';
import { setupHoverVideoHandlers } from '../utils/videoHandler';
import { useIsMobile } from '../hooks/use-mobile';

const Shows = () => {
  const isMobile = useIsMobile();
  const showsRef = useRef<HTMLDivElement | null>(null);
  const footerRef = useRef<HTMLDivElement | null>(null);
  const videoRef = useRef<HTMLVideoElement | null>(null);

  const [modalOpen, setModalOpen] = useState(false);
  const [modalData, setModalData] = useState<any>(null);

  const openModal = (item: any) => {
    setModalData(item);
    setModalOpen(true);
  };

  const playFullscreen = () => {
    const video = videoRef.current;
    if (video) {
      if (video.requestFullscreen) {
        video.requestFullscreen();
      } else if ((video as any).webkitEnterFullscreen) {
        (video as any).webkitEnterFullscreen();
      } else if ((video as any).mozRequestFullScreen) {
        (video as any).mozRequestFullScreen();
      } else if ((video as any).msRequestFullscreen) {
        (video as any).msRequestFullscreen();
      }
      video.play();
    }
  };

  useEffect(() => {
    setupHoverVideoHandlers();
  }, []);

  const destaque = {
    id: '1',
    title: 'Pra não pensar em você',
    imageSrc: '/img/zeze&luciano.jpg',
    videoSrc: '/videos/zeze&luciano.mp4',
    embedId: '1c9ac0159c94d8d0cbedc973445af2da',
    description: 'Show exclusivo da dupla sertaneja que marcou gerações.'
  };

  const showsPopulares = [
    destaque,
    {
      id: '2',
      title: 'Ed. & Hud.- Jaguariuna',
      imageSrc: '/img/edson_hudson.png',
      videoSrc: '/videos/Edson_Hudson.mp4',
      embedId: '2a79ea27c279e471f4d180b08d62b00a',
      description: 'Gravação inesquecível no rodeio de Jaguariúna com Edson & Hudson.'
    },
    {
      id: '3',
      title: 'Victor e Leo | Irmãos',
      imageSrc: '/img/Victor_e_Leo.jpg',
      videoSrc: '/videos/victor_e_leo.mp4',
      embedId: '0777d5c17d4066b82ab86dff8a46af6f',
      description: 'A volta dos irmãos com um show emocionante.'
    },
    {
      id: '4',
      title: 'Chitãozinho e Xororó | Turnê 50 anos',
      imageSrc: '/img/chitaozinho-e-xororo.jpg',
      videoSrc: '/videos/Chitaozinho_e_Xororo.mp4',
      embedId: '82aa4b0af34c2313a562076992e50aa3',
      description: 'Comemorando 50 anos de carreira com um espetáculo histórico.'
    },
    {
      id: '5',
      title: 'Fernando & Sorocaba | Jaguariuna',
      imageSrc: '/img/fernando_sorocaba.jpeg',
      videoSrc: '/videos/fernando_sorocaba.mp4',
      embedId: 'b73ce398c39f506af761d2277d853a92',
      description: 'Fernando & Sorocaba no auge em Jaguariúna.'
    },
    {
      id: '6',
      title: 'Ao vivo: Jaguariúna',
      imageSrc: '/img/edson_hudson.png',
      videoSrc: '/videos/Edson_Hudson.mp4',
      embedId: '2a79ea27c279e471f4d180b08d62b00a',
      description: 'Show ao vivo em Jaguariúna com Edson & Hudson.'
    },
    {
      id: '7',
      title: 'Fernando & Sorocaba | Ao Vivo',
      imageSrc: '/img/fernando_sorocaba.jpeg',
      videoSrc: '/videos/fernando_sorocaba.mp4',
      embedId: '3b89eb33c38a5d62f4d270b09d63c00b',
      description: 'Apresentação eletrizante da dupla em show ao vivo.'
    }
  ];

  const showsRecentes = [
    {
      id: '1',
      title: 'Victor & Leo | Acústico',
      imageSrc: '/img/Victor_e_Leo.jpg',
      videoSrc: '/videos/victor_e_leo.mp4',
      embedId: 'fa7cdfad1a5aaf8370ebeda47a1ff1c3',
      description: 'Uma versão acústica especial de Jorge & Mateus.'
    },
    {
      id: '2',
      title: 'Maiara & Maraisa | Show Especial',
      imageSrc: '/img/maiara_e_maraisa.png',
      videoSrc: '/videos/Maiara_e_Maraisa.mp4',
      embedId: 'a4a042cf4fd6bfb47701cbc8a1653ada',
      description: 'Emocionante apresentação de Maiara & Maraisa.'
    },
    {
      id: '3',
      title: 'Bruno & Marrone | Em Casa',
      imageSrc: '/img/bruno_e_marrone.png',
      videoSrc: '/videos/Bruno_Marrone_Feriando_Nacional.mp4',
      embedId: '1ff8a7b5dc7a7d1f0ed65aaa29c04b1e',
      description: 'Show intimista da dupla diretamente de casa.'
    }
  ];

  return (
    <div className="bg-[#141414]">
      <Header />

      <main className="pt-[70px] sm:pt-[80px] md:pt-[90px] p-3 sm:p-4 md:p-5 overflow-visible relative">
        <div className="container mx-auto px-0 max-w-full">
          <div className="relative w-full h-[85vh] overflow-hidden rounded-lg shadow-lg mb-10">
            <video
              ref={videoRef}
              className="absolute inset-0 w-full h-full object-cover"
              src={destaque.videoSrc}
              autoPlay
              muted
              loop
              playsInline
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/50 to-transparent flex flex-col justify-end p-8">
              <div className="max-w-[600px] bg-black/50 p-6 rounded-lg">
                <h1 className="text-white text-3xl md:text-4xl font-bold">
                  {destaque.title}
                </h1>
                <p className="text-white/90 text-sm md:text-base mt-2">
                  {destaque.description}
                </p>

                <div className="flex gap-4 mt-4 w-full max-w-[500px]">
                  <button
                    className="flex items-center justify-center gap-2 px-[20px] h-[48px] rounded font-bold text-rustico-brown bg-white hover:bg-[#bbab95] transition-colors flex-1"
                    onClick={playFullscreen}
                  >
                    <span className="material-symbols-outlined text-[20px]">play_arrow</span>
                    ASSISTIR
                  </button>
                  <button
                    className="flex items-center justify-center gap-2 px-[20px] h-[48px] rounded font-medium text-white bg-[rgba(255,255,255,0.3)] hover:bg-[rgba(255,255,255,0.5)] transition-colors flex-1"
                    onClick={() => openModal(destaque)}
                  >
                    INFORMAÇÕES
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div ref={showsRef}>
            <ContentRow
              title="Shows Populares"
              items={showsPopulares}
              category="shows-populares"
              fullWidth={true}
            />
            <ContentRow
              title="Shows Recentes"
              items={showsRecentes}
              category="shows-recentes"
              fullWidth={true}
            />
          </div>
        </div>
      </main>

      <div ref={footerRef}>
        <Footer />
      </div>

      {modalOpen && modalData && (
        <ContentModal item={modalData} onClose={() => setModalOpen(false)} />
      )}
    </div>
  );
};

export default Shows;
